const doc = [({"en":({"js":({"layout":({"no_access":({"no_access":"No access", "you_dont_have_access_to_the_requested_resource":"You didn't have access to the requested resource."})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;